import React from 'react';
import Box from '@amzn/meridian/box';
import Heading from '@amzn/meridian/heading';
import Text from '@amzn/meridian/text';
import DataTable, {
  DataTableHead,
  DataTableBody,
  DataTableRow,
  DataTableCell,
  DataTableHeader,
} from '@amzn/meridian/data-table';
import { LeaderboardTableProps } from '../model';
import { formatTriggersMet } from '../../../utils/leaderboard-utils';

const LeaderboardTable: React.FC<LeaderboardTableProps> = ({ entries }) => {
  if (!entries || entries.length === 0) {
    return null;
  }

  return (
    <Box spacingInset="400 none">
      <Heading level={3} className="leaderboard-title">All Sites</Heading>
      <Text type="b200" color="secondary">
        Ranked by shift plans generated last week
      </Text>
      <Box spacingInset="300 none">
        <DataTable
          size="large"
          showRowDividers
          showColumnDividers={false}
          showStripes={false}
          showBorder
          width="100%"
        >
          <DataTableHead>
            <DataTableRow>
              <DataTableHeader>Rank</DataTableHeader>
              <DataTableHeader>Site</DataTableHeader>
              <DataTableHeader>Shift Plans</DataTableHeader>
              <DataTableHeader>Day Plans</DataTableHeader>
              <DataTableHeader>Night Plans</DataTableHeader>
              <DataTableHeader>Days Active</DataTableHeader>
            </DataTableRow>
          </DataTableHead>
          <DataTableBody>
            {entries.map((entry) => {
              return (
                <DataTableRow key={entry.site} highlightOnHover>
                  <DataTableCell>
                    <Text>{entry.rank ?? '-'}</Text>
                  </DataTableCell>
                  <DataTableCell>
                    <Text type="b300">{entry.site}</Text>
                  </DataTableCell>
                  <DataTableCell>
                    <Text>{entry.planCount ?? 0}</Text>
                  </DataTableCell>
                  <DataTableCell>
                    <Text>{entry.dayPlans ?? 0}</Text>
                  </DataTableCell>
                  <DataTableCell>
                    <Text>{entry.nightPlans ?? 0}</Text>
                  </DataTableCell>
                  <DataTableCell>
                    <Text>{formatTriggersMet(entry.daysActive ?? 0)}</Text>
                  </DataTableCell>
                </DataTableRow>
              );
            })}
          </DataTableBody>
        </DataTable>
      </Box>
    </Box>
  );
};

export default LeaderboardTable;
